// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pli-dili {
  padding-bottom: 20px;
}
.pli-dili__form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 12px;
}
.pli-dili__common {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.pli-dili__row {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
  margin: 0;
  padding: 12px;
  border: 1px solid var(--border-soft);
  border-radius: 6px;
}
.pli-dili__legend {
  padding: 0 4px;
  font-size: var(--fs-ui);
  color: var(--text);
}
.pli-dili__recipients {
  margin: 12px 0 0;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: var(--fs-ui);
  color: var(--text);
  overflow-wrap: anywhere;
}
.pli-dili__row .plp-morebtn,
.pli-dili__form .plp-rowbtn,
.pli-dili .form-input {
  min-height: 44px;
}

/* Bajo 480px la etiqueta va sobre el campo: el grid de 130px deja los inputs
   demasiado angostos para una dirección. */
@media (max-width: 480px) {
  .pli-dili .input-row {
    grid-template-columns: 1fr;
    gap: 6px;
  }
  .pli-dili .input-row > .helper-text {
    grid-column: 1;
    margin-top: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/plataforma/whatsapp/ChannelDiligencePanel.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,SAAS;EACT,aAAa;EACb,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;;;EAGE,gBAAgB;AAClB;;AAEA;2CAC2C;AAC3C;EACE;IACE,0BAA0B;IAC1B,QAAQ;EACV;EACA;IACE,cAAc;IACd,aAAa;EACf;AACF","sourcesContent":[".pli-dili {\n  padding-bottom: 20px;\n}\n.pli-dili__form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-top: 12px;\n}\n.pli-dili__common {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.pli-dili__row {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  min-width: 0;\n  margin: 0;\n  padding: 12px;\n  border: 1px solid var(--border-soft);\n  border-radius: 6px;\n}\n.pli-dili__legend {\n  padding: 0 4px;\n  font-size: var(--fs-ui);\n  color: var(--text);\n}\n.pli-dili__recipients {\n  margin: 12px 0 0;\n  padding-left: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  font-size: var(--fs-ui);\n  color: var(--text);\n  overflow-wrap: anywhere;\n}\n.pli-dili__row .plp-morebtn,\n.pli-dili__form .plp-rowbtn,\n.pli-dili .form-input {\n  min-height: 44px;\n}\n\n/* Bajo 480px la etiqueta va sobre el campo: el grid de 130px deja los inputs\n   demasiado angostos para una dirección. */\n@media (max-width: 480px) {\n  .pli-dili .input-row {\n    grid-template-columns: 1fr;\n    gap: 6px;\n  }\n  .pli-dili .input-row > .helper-text {\n    grid-column: 1;\n    margin-top: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
